import * as React from 'react';
import { space } from 'styled-system';
import styled from 'styled-components';
import { Spring, config, animated } from 'react-spring/renderprops.cjs';

import { images, theme } from '../theme';
import { H3 } from '../typography';
import { LoginForm } from '../forms';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { IS_VENDOR } from '../consts/index';

const PanelWrapper = styled(animated.div)<StyledSystemProps>`
  ${space};
  top: 0;
  left: 0;
  bottom: 0;
  width: 350px;
  display: flex;
  z-index: ${theme.zIndex[15]};
  max-width: 100%;
  position: fixed;
  overflow-y: auto;
  background: white;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  box-shadow: 5px 0px 10px -8px rgba(0, 0, 0, 0.4), -12px 0 8px -4px rgba(0, 0, 0, 0.2);
`;

const Logo = styled.img`
  display: inline-block;
  max-width: 100%;
  height: auto;
  width: 60%;
`;

type Props = {};

type State = {};

export default class LoginPanel extends React.Component<Props, State> {
  public render() {
    return (
      <Spring
        native={true}
        delay={500}
        config={config.default}
        from={{ opacity: 0, transform: 'translateX(-300px)' }}
        to={{ opacity: 1, transform: 'translateX(0)' }}
      >
        {props => (
          <PanelWrapper p={5} style={props}>
            <Logo src={images.logo} />
            <H3 fontWeight={100} my={4} color="charcoalGrey">
              {IS_VENDOR ? 'VENDOR LOGIN' : 'LOGIN'}
            </H3>
            <LoginForm isVendor={IS_VENDOR} />
          </PanelWrapper>
        )}
      </Spring>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginPanel.tsx